// app/javascript/compcalc/index.js

import React from 'react';
// import ReactDOM from 'react-dom';
// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import AppWithTheme from './components/AppWithTheme';


const rootElement = document.querySelector('#compcalc');
// ReactDOM.render(<AppWithTheme />, compcalc);

const root = createRoot(rootElement);

root.render(
  // <StrictMode>
  <AppWithTheme />
  // <StrictMode/>
);
